import { keepTwoOrLine } from '@/utils/utils';
import circle_spin from '../../../imgs/circle_spin.png';

interface PieDataItem {
  name: string;
  value: number;
  rate: number;
  cost: string;
  color: string;
}

export const getDeviceTypePieChartOption = (data: PieDataItem[], total: string) => {
  const colors = ['#2D8DFF', '#FF477B', '#FFCB47', '#9B59B6', '#16DD8E', '#52E7FF'];

  const pieData = data.map((item, i) => ({
    name: item.name ?? '--',
    value: item.value ?? 0,
    rate: item.rate ?? 0,
    cost: item.cost,
    itemStyle: { color: colors[i % colors.length] },
  }));

  return {
    color: colors,
    legend: { show: false },
    tooltip: {
      trigger: 'item',
      confine: true,
      formatter: (params: any) => {
        const { data } = params;
        return `
          <div style="padding: 8px;">
            <div style="margin-bottom: 4px;">${data.name}</div>
            <div>用能：${data.cost}</div>
            <div>占比：${keepTwoOrLine(data.rate)}%</div>
          </div>
        `;
      },
    },
    graphic: {
      elements: [
        {
          type: 'image',
          style: {
            image: circle_spin,
            x: 60,
            y: 40,
            width: 90,
            height: 90,
          },
          keyframeAnimation: [
            {
              duration: 50000,
              loop: true,
              easing: 'linear',
              keyframes: [
                { percent: 0, rotation: 0, transition: ['rotation'] },
                { percent: 1, rotation: 360, transition: ['rotation'] },
              ],
            },
          ],
          origin: [105, 85],
          tooltip: { show: false },
        },
      ],
    },
    series: [
      {
        type: 'pie',
        name: '设备类型用能',
        percentPrecision: 2,
        minAngle: 2,
        padAngle: 1,
        radius: [52, 60],
        left: 72,
        top: 52,
        width: 66,
        height: 66,
        label: {
          show: true,
          position: 'center',
          formatter: () => `{value|${total}}\n{unit|总计(kWh)}`,
          rich: {
            value: {
              fontSize: 20,
              fontWeight: 600,
              color: '#FFF',
            },
            unit: {
              fontSize: 12,
              color: '#FFF',
              padding: [4, 0, 0, 0],
            },
          },
        },
        data: pieData,
        showEmptyCircle: false,
      },
      {
        showEmptyCircle: false,
        data: pieData,
        type: 'pie',
        percentPrecision: 2,
        padAngle: 1,
        minAngle: 2,
        left: 72,
        top: 52,
        name: '设备类型用能',
        radius: [60, 76],
        width: 66,
        height: 66,
        emphasis: { disabled: true },
        label: { show: false },
        itemStyle: { opacity: 0.2 },
      },
    ],
  };
};
